import { render, staticRenderFns } from "./MedicalInsuranceLevelInfo.vue?vue&type=template&id=13cb720b&scoped=true&"
import script from "./MedicalInsuranceLevelInfo.vue?vue&type=script&lang=js&"
export * from "./MedicalInsuranceLevelInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cb720b",
  null
  
)

export default component.exports